<template>
    <div class="main-wrapper">
        <div class="container">
            <div class="content-card">
                <h2 class="error-title">Something Went Wrong</h2>
                <p class="error-message">
                    {{ 'Sorry, but your link is incorrect or has expired.' }}
                </p>
                <p class="error-instruction">
                    Please check your link or contact support if the issue persists.
                </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

export default {
}
</script>
<style scoped>
.main-wrapper {
    min-height: 100vh;
    background: #f0f0f0;
    padding-top: 20px;
    display: flex;
    justify-content: center;
}

.container {
    width: 100%;
    padding: 0 16px;
}

.content-card {
    background: white;
    border-radius: 12px;
    padding: 24px;
    text-align: center;
}

.error-title {
    font-size: clamp(1.5rem, 5vw, 1.75rem);
    font-weight: 600;
    color: #333333;
    margin-bottom: 16px;
}

.error-message {
    font-size: clamp(1rem, 4vw, 1.125rem);
    color: #d82332;
    margin-bottom: 12px;
    line-height: 1.5;
}

.error-instruction {
    font-size: clamp(0.875rem, 3.5vw, 1rem);
    color: #666666;
    margin-bottom: 24px;
}

@media (min-width: 600px) {
    .content-card {
        max-width: 500px;
        margin: auto;
        padding: 32px;
    }

    .main-wrapper {
        padding-top: 60px;
    }

    .error-title {
        font-size: clamp(1.75rem, 4vw, 2rem);
    }

    .error-message {
        font-size: clamp(1.125rem, 3.5vw, 1.25rem);
        font-weight: 500;
    }
}
</style>
